import { render, staticRenderFns } from "./IndexComponent.vue?vue&type=template&id=ddccae7e&scoped=true&"
import script from "./IndexComponent.vue?vue&type=script&lang=js&"
export * from "./IndexComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndexComponent.vue?vue&type=style&index=0&id=ddccae7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddccae7e",
  null
  
)

export default component.exports